// INFO: The DOM id of a source. It is needed to preserve the focus on a message source througout re-renders
export const toSourceElementId = (messageId: string, href: string, offset = 0) =>
  `source-${messageId}-${offset}-${encodeURIComponent(href)}`;
